import { cn } from '@/lib/utils'
import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react'

export function Table({ className, ...props }) {
  return (
    <div className="w-full overflow-x-auto">
      <table className={cn('w-full text-sm border-collapse', className)} {...props} />
    </div>
  )
}

export function THead({ className, ...props }) {
  return <thead className={cn('text-left text-muted-foreground', className)} {...props} />
}

export function TH({ className, ...props }) {
  return <th className={cn('font-medium px-4 py-2.5 border-b border-border', className)} {...props} />
}

export function SortableTH({ children, sortKey, activeSortKey, direction, onSort, className, align = 'left' }) {
  const active = sortKey === activeSortKey
  const Icon = active ? (direction === 'asc' ? ArrowUp : ArrowDown) : ArrowUpDown

  return (
    <TH
      aria-label={typeof children === 'string' ? children : undefined}
      aria-sort={active ? (direction === 'asc' ? 'ascending' : 'descending') : 'none'}
      className={cn('cursor-pointer select-none', className)}
    >
      <button
        type="button"
        aria-label={typeof children === 'string' ? `Ordenar por ${children}` : 'Ordenar coluna'}
        onClick={() => onSort(sortKey)}
        className={cn(
          'flex w-full cursor-pointer items-center gap-1.5 whitespace-nowrap',
          align === 'right' && 'justify-end',
          align === 'center' && 'justify-center'
        )}
      >
        {children}
        <Icon aria-hidden="true" className={cn('h-3.5 w-3.5 shrink-0', !active && 'opacity-35')} />
      </button>
    </TH>
  )
}

export function TBody(props) {
  return <tbody {...props} />
}

/** Linha com zebra + hover sutis (índice par/ímpar). */
export function TR({ className, index, clickable, ...props }) {
  return (
    <tr
      className={cn(
        index % 2 === 1 ? 'bg-muted/40' : 'bg-transparent',
        'hover:bg-accent/50 transition-colors',
        clickable && 'cursor-pointer',
        className
      )}
      {...props}
    />
  )
}

export function TD({ className, ...props }) {
  return <td className={cn('px-4 py-2.5 border-b border-border/60', className)} {...props} />
}
